import PageBreadcrumb from "../components/common/PageBreadCrumb";
import PageMeta from "../components/common/PageMeta";
import UsersTable from "../components/tables/UsersTable";

export default function UsersPage() {
    return (
        <>
            <PageMeta
                title="Users Management | Shoplattice Admin Dashboard"
                description="Manage system users and clients"
            />
            <PageBreadcrumb pageTitle="Users Management" />
            <div className="space-y-6">
                <UsersTable />
            </div>
        </>
    );
}
